<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img
            class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user.photo_profile"
            [src]="user.photo_profile.thumbnail_150">
        <mat-icon
            *ngIf="!showAvatar || !user.photo_profile"
            [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
         
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item [routerLink]="['/my-photo']">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Déconnexion</span>
    </button>
</mat-menu>
